import { createNativeStackNavigator } from "@react-navigation/native-stack";
import React from "react";
import Login from "web/components/auth/Login.component";
import {
  AUTH_SCREEN_NAMES,
  SCREEN_ADMIN_FORGOT,
  SCREEN_ADMIN_LOGIN,
  SCREEN_ADMIN_REGISTER,
  SCREEN_CONTACT,
  SCREEN_PRIVACY,
  SCREEN_RESET_PASSWORD,
} from "web/constants";
import ContactUs from "webComponentsAuth/Contact.component";
import ForgotPassword from "webComponentsAuth/ForgotPassword.component";
import PrivacyPolicy from "webComponentsAuth/PrivacyPolicy.component";
import ResetPassword from "webComponentsAuth/ResetPassword.component";
import Register from "./Register.component";

const Stack = createNativeStackNavigator();

export default function AuthStack() {
  return (
    <Stack.Navigator
      screenOptions={(options) => ({
        headerShown: false,
        title: `${AUTH_SCREEN_NAMES[options.route.name]} | Business Continuity Plan`,
      })}
    >
      <Stack.Screen name={SCREEN_ADMIN_LOGIN} component={Login} />
      <Stack.Screen name={SCREEN_ADMIN_FORGOT} component={ForgotPassword} />
      <Stack.Screen name={SCREEN_RESET_PASSWORD} component={ResetPassword} />
      <Stack.Screen name={SCREEN_PRIVACY} component={PrivacyPolicy} />
      <Stack.Screen name={SCREEN_CONTACT} component={ContactUs} />
      <Stack.Screen name={SCREEN_ADMIN_REGISTER} component={Register} />
      {/* <Stack.Screen
        name={SCREEN_CREATE_ORGANIZATION}
        component={CreateOrganization}
      /> */}
    </Stack.Navigator>
  );
}
